module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iShJX"))).then(() => parcelRequire('hEqeo'));